<kendo-window title="Document Viewer: {{fileName}}"
              *ngIf="isWindow && fileName.length > 0"
              (close)="close()"
              [top]="100"
              [minWidth]="500"
              [style]="{'width':'80%','height':'700px'}">
    <!--<iframe id="documentViewer" src="{{fileUri}}" width="100%" height="100%"></iframe>-->
    <kendo-pdfviewer style="width: 80%; height: 600px;" [url]="fileUri" *ngIf="isPDF"></kendo-pdfviewer>
    <!--<ngx-extended-pdf-viewer [src]="fileUri" *ngIf="isPDF"q></ngx-extended-pdf-viewer>-->
    <div *ngIf="!isPDF">
        Viewer not supported for non-PDF files. You may <a href="{{fileUri}}" target="_blank">download the file</a> instead.
    </div>
</kendo-window>
<div *ngIf="!isWindow && fileName.length > 0">
    <kendo-pdfviewer style="width: 90%; height: 800px;" [url]="fileUri" *ngIf="isPDF"></kendo-pdfviewer>
    <div *ngIf="!isPDF">
        Viewer not supported for non-PDF files. You may <a href="{{fileUri}}" target="_blank">download the file</a> instead.
    </div>
</div>
